module.exports = __webpack_public_path__ + "img/s0.4e4f3f40.png";